import { GatsbyImage } from 'gatsby-plugin-image';
import propType from 'prop-types';
import React from 'react';

const BravoImage = ({ src, alt, ...props }) => {
  const image = src?.node?.localFile?.childImageSharp?.gatsbyImageData;
  return (
    <>
      {image ? (
        <GatsbyImage image={image} alt={alt} {...props} />
      ) : (
        <img
          alt={alt}
          src="/images/thumbnails/bravo-thumbnail.png"
          className={props}
        />
      )}
    </>
  );
};

BravoImage.defaultProps = {
  src: null,
  alt: 'Image'
};

BravoImage.propTypes = {
  src: propType.shape({
    node: propType.shape({
      localFile: propType.shape({
        childImageSharp: propType.shape({
          gatsbyImageData: propType.shape({}).isRequired
        })
      })
    })
  }),
  alt: propType.string
};

export default BravoImage;
